import React from 'react'
import './styles.scss'
import { ElementAccordion } from 'components/ElementAccordion'
import DataWrapperChart from 'components/DataWrapperChart'
import { SectionTitle } from 'components/SectionTitle'

const isMobile = window.innerWidth < 712

export const WastewaterCharts = ({}: {}) => {
  return (
    <div className='WastewaterCharts'>
      <div className='chart'>
        <SectionTitle
          main='Covid-Gensequenzen im Abwasser von Kläranlagen'
          sub='Tägliche Messwerte und der Trend als 7-Tage Median'
          update='Wird mehrmals pro Woche aktualisiert'
        />
      </div>
      <ElementAccordion
        items={['Xh2WN', '1H6e7']}
        additionalItems={['q4P57', 'pHzh3', 'ae5G7', 'lKDN3']}
        buttonLabels={{
          open: 'Zusätzliche Kläranlagen ausblenden...',
          closed: 'Mehr Kläranlagen anzeigen...'
        }}
        element={(item: string, i?: number) => (
          <div className={'element ' + (i && i % 2 ? 'right' : 'left')}>
            <DataWrapperChart
              chartId={item}
              id={'abwasser_' + Math.random()}
              height={isMobile ? 270 : 380}
            />
          </div>
        )}
      />
    </div>
  )
}
